import { BitfDefaultResponseMapper } from '../default-parser/bitf-default-response.mapper';
export abstract class BitfPResponseMapper extends BitfDefaultResponseMapper {}
